interface Props {
  filters: Record<string, string>;
  onRemove: (key: string) => void;
  onClear: () => void;
}

export function PortfolioFilterBar({ filters, onRemove, onClear }: Props) {
  const entries = Object.entries(filters);
  if (entries.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-body-sm text-text-muted mr-1">Filters:</span>
      {entries.map(([key, value]) => (
        <button
          key={`${key}:${value}`}
          onClick={() => onRemove(key)}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-surface-600 text-body-sm text-text-secondary hover:bg-surface-500 transition-colors"
        >
          <span className="text-text-muted">{key}:</span>
          <span>{value}</span>
          <svg className="w-3.5 h-3.5 ml-0.5 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      ))}
      <button
        onClick={onClear}
        className="text-body-sm text-text-muted hover:text-text-primary transition-colors"
      >
        Clear all
      </button>
    </div>
  );
}
